module.exports = __webpack_public_path__ + "images/for_company_page/voice-farmally_aa7213e7bc60dc05300d50d59ac5a63c.jpg";